import { IRecordLengthPicker } from '../../types';
import { useTranslation } from 'react-i18next';
import { FormControl, Select, MenuItem } from '@mui/material';
import { RecordLength } from '../data/Constants';

/**
 * Allow to select records Per Page component
 * @param {IRecordLengthPicker} props has limit and callback function
 * @returns JSX
 */

export const RecordLengthPicker = (props: IRecordLengthPicker) => {
  const { limit, handleRecordsChange } = props;
  const { t } = useTranslation();
  const list = props?.list ?? RecordLength;
  return (
    <div id="data-table-records" className="d-flex align-center recordPicker">
      {t('labels.recordsPerPage') + ':'}&emsp;
      <FormControl id="data-table-records" size="small" className="" style={{ width: '5.4rem' }}>
        <Select
          id="data-table-record-select"
          data-testid="data-table-record-select"
          name="recordsPerPage"
          value={limit}
          onChange={handleRecordsChange}
        >
          {list.map((range) => (
            <MenuItem key={range} value={range}>
              {range}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};
